import { useSite } from "@/context/SiteSettings";

const Diamond = () => (
    <svg viewBox="0 0 10 10" className="w-2 h-2 shrink-0 text-amber-500/80" fill="currentColor" aria-hidden="true">
        <path d="M5 0 L10 5 L5 10 L0 5 Z" />
    </svg>
);

const Row = ({ phrases }) => (
    <div className="flex items-center gap-10 pr-10 shrink-0">
        {phrases.map((p) => (
            <span key={p} className="flex items-center gap-10">
                <span className="font-display text-lg sm:text-xl font-semibold uppercase tracking-[0.25em] text-zinc-500 whitespace-nowrap">
                    {p}
                </span>
                <Diamond />
            </span>
        ))}
    </div>
);

export const Marquee = ({ className = "" }) => {
    const { t } = useSite();
    const phrases = [t("banner_1"), t("banner_2"), t("banner_3"), t("banner_4")].filter(Boolean);
    return (
    <div
        data-testid="editorial-marquee"
        className={`relative overflow-hidden border-y border-amber-500/15 bg-black/40 py-5 ${className}`}
    >
        <div className="flex w-max animate-marquee">
            <Row phrases={phrases} />
            <Row phrases={phrases} />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0A0E] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0A0E] to-transparent" />
    </div>
    );
};

export default Marquee;
